import { useMutation } from 'react-query';
import httpClient from '../datasources/httpClient';

export default function useMutationWorkspaces({ onSuccess, onError }) {
  return useMutation(
    ({ name }) => httpClient.post('workspaces', { name }),
    {
      onError,
      onSuccess,
    },
  );
}
